import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { ICreateCadastroCoresUseCase } from "../../../presentation/useCases/create/create_cadastro_cores_use_case";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

/**
 * CreateCadastroCoresUseCase
 */

export class CreateCadastroCoresUseCase implements ICreateCadastroCoresUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) { }

  async createCadastroCores(
    dataInicio: Date,
    dataFinal: Date,
    idCor: number,
    cor: string | undefined,
    corValor: string | undefined,
  ): Promise<void> {
    if (cor === undefined) throw new UserFriendlyError('A cor selecionada é inválida!');
    if (corValor === undefined) throw new UserFriendlyError('A cor selecionada é inválida!');
    await this.repository.createCadastroCores(
      dataInicio,
      dataFinal,
      idCor,
      cor,
      corValor,
    );
  }
}
